export default {
  Required: 'required',
  DiffierentZero: 'diffierentZero',
  GreaterThanZero: 'greaterThanZero',
  Pattern: 'pattern',
  ForceSelection: 'forceSelection',
  MissingValue: 'missingValue',
  DuplicateRow: 'duplicateRow',
  LengthAmount: 'lengthAmount',
  RiskCustomerVendor: 'riskCustomerVendor',
};
